import vagonOpen from '../images/vagonopen.png';
import sidImage from '../images/sid.png';
import catNoBilet from '../images/catbesbileta.png';
import trash from '../images/trash.png'
import conductor from '../images/ktskey.png'

const unmaterial = true;
const testColor = true;

export const vagon = {
  position: {
    x: -200,
    y: -200
  },
  size: {
    width: 400,
    height: 600
  },
  image: vagonOpen
};

export const vagon2 = {
  position: {
    x: -200,
    y: 1800
  },
  size: {
    width: 400,
    height: 600
  },
  image: vagonOpen
};

export const vagon3 = {
  position: {
    x: -200,
    y: 3800
  },
  size: {
    width: 400,
    height: 600
  },
  image: vagonOpen
};

const sid = {
  size: {
    width: 60,
    height: 60
  }
};

export const walls1 = [
  { id: 'wallVagon', position: vagon.position, size: vagon.size, image: vagonOpen, unmaterial },
  { id: 'wallTopVagonWall', position: vagon.position, size: { width: vagon.size.width, height: 20 } },
  { id: 'wallLeftVagonWall', position: vagon.position, size: { width: 1, height: vagon.size.height } },
  { id: 'wallRightVagonWall', position: { x: vagon.position.x + vagon.size.width, y: vagon.position.y }, size: { width: 20, height: vagon.size.height }, testColor },
  { id: 'wallBottomVagonWall', position: { x: vagon.position.x, y: vagon.position.y + vagon.size.height - 10 }, size: { width: vagon.size.width, height: 20 }, testColor },
  { id: 'wallSidLeftTop', position: { x: vagon.position.x, y: vagon.position.y + 150 }, size: { width: sid.size.width, height: sid.size.height }, image: sidImage, unmaterial },
  { id: 'wallSidLeftMiddle', position: { x: vagon.position.x, y: vagon.position.y + 300 }, size: { width: sid.size.width, height: sid.size.height }, image: sidImage, unmaterial },
  { id: 'wallSidLeftBottom', position: { x: vagon.position.x, y: vagon.position.y + 450 }, size: { width: sid.size.width, height: sid.size.height }, image: sidImage, unmaterial },
  { id: 'wallSidRightTop', position: { x: vagon.position.x + vagon.size.width - 139, y: vagon.position.y + 150 }, size: { width: sid.size.width, height: sid.size.height }, image: sidImage, unmaterial },
  { id: 'wallSidRightMiddle', position: { x: vagon.position.x + vagon.size.width - 139, y: vagon.position.y + 300 }, size: { width: sid.size.width, height: sid.size.height }, image: sidImage, unmaterial },
  { id: 'wallSidRightBottom', position: { x: vagon.position.x + vagon.size.width - 139, y: vagon.position.y + 450 }, size: { width: sid.size.width, height: sid.size.height }, image: sidImage, unmaterial },
];

export const walls2 = [
  { id: 'wall2Vagon', position: vagon2.position, size: vagon2.size, image: vagonOpen, unmaterial },
  { id: 'wall2TopVagonWall', position: vagon2.position, size: { width: vagon2.size.width, height: 20 } },
  { id: 'wall2LeftVagonWall', position: vagon2.position, size: { width: 1, height: vagon2.size.height } },
  { id: 'wall2RightVagonWall', position: { x: vagon2.position.x + vagon2.size.width, y: vagon2.position.y }, size: { width: 20, height: vagon2.size.height }, testColor },
  { id: 'wall2BottomVagonWall', position: { x: vagon2.position.x, y: vagon2.position.y + vagon2.size.height - 10 }, size: { width: vagon2.size.width, height: 20 }, testColor },
  { id: 'wall2SidLeftTop', position: { x: vagon2.position.x, y: vagon2.position.y + 150 }, size: { width: sid.size.width, height: sid.size.height }, image: sidImage, unmaterial },
  { id: 'wall2SidLeftMiddle', position: { x: vagon2.position.x, y: vagon2.position.y + 300 }, size: { width: sid.size.width, height: sid.size.height }, image: sidImage, unmaterial },
  { id: 'wall2SidLeftBottom', position: { x: vagon2.position.x, y: vagon2.position.y + 450 }, size: { width: sid.size.width, height: sid.size.height }, image: sidImage, unmaterial },
  { id: 'wall2SidRightTop', position: { x: vagon2.position.x + vagon2.size.width - 139, y: vagon2.position.y + 150 }, size: { width: sid.size.width, height: sid.size.height }, image: sidImage, unmaterial },
  { id: 'wall2SidRightMiddle', position: { x: vagon2.position.x + vagon2.size.width - 139, y: vagon2.position.y + 300 }, size: { width: sid.size.width, height: sid.size.height }, image: sidImage, unmaterial },
  { id: 'wall2SidRightBottom', position: { x: vagon2.position.x + vagon2.size.width - 139, y: vagon2.position.y + 450 }, size: { width: sid.size.width, height: sid.size.height }, image: sidImage, unmaterial },
]

export const walls3 = [
  { id: 'wall3Vagon', position: vagon3.position, size: vagon3.size, image: vagonOpen, unmaterial },
  { id: 'wall3TopVagonWall', position: vagon3.position, size: { width: vagon3.size.width, height: 20 } },
  { id: 'wall3LeftVagonWall', position: vagon3.position, size: { width: 1, height: vagon3.size.height } },
  { id: 'wall3RightVagonWall', position: { x: vagon3.position.x + vagon3.size.width, y: vagon3.position.y }, size: { width: 20, height: vagon3.size.height }, testColor },
  { id: 'wall3BottomVagonWall', position: { x: vagon3.position.x, y: vagon3.position.y + vagon3.size.height - 10 }, size: { width: vagon3.size.width, height: 20 }, testColor },
  { id: 'wall3SidLeftTop', position: { x: vagon3.position.x, y: vagon3.position.y + 150 }, size: { width: sid.size.width, height: sid.size.height }, image: sidImage, unmaterial },
  { id: 'wall3SidLeftMiddle', position: { x: vagon3.position.x, y: vagon3.position.y + 300 }, size: { width: sid.size.width, height: sid.size.height }, image: sidImage, unmaterial },
  { id: 'wall3SidLeftBottom', position: { x: vagon3.position.x, y: vagon3.position.y + 450 }, size: { width: sid.size.width, height: sid.size.height }, image: sidImage, unmaterial },
  { id: 'wall3SidRightTop', position: { x: vagon3.position.x + vagon3.size.width - 139, y: vagon3.position.y + 150 }, size: { width: sid.size.width, height: sid.size.height }, image: sidImage, unmaterial },
  { id: 'wall3SidRightMiddle', position: { x: vagon3.position.x + vagon3.size.width - 139, y: vagon3.position.y + 300 }, size: { width: sid.size.width, height: sid.size.height }, image: sidImage, unmaterial },
  { id: 'wall3SidRightBottom', position: { x: vagon3.position.x + vagon3.size.width - 139, y: vagon3.position.y + 450 }, size: { width: sid.size.width, height: sid.size.height }, image: sidImage, unmaterial },
]

export const interactiveObjects = [
  { id: 'interactiveCarNoBilet', position: {x: vagon.position.x + 300, y: vagon.position.y + 40}, size: {width: 100, height: 100}, image: catNoBilet},
  { id: 'interactiveDoor1Top', position: {x: vagon.position.x + vagon.size.width / 2 - 50, y: vagon.position.y}, size: {width: 100, height: 100}},
  { id: 'interactiveDoor1Down', position: {x: vagon.position.x + vagon.size.width / 2 - 50, y: vagon.position.y + vagon.size.height - 110}, size: {width: 100, height: 100}},

  { id: 'interactiveConductor', position: {x: vagon2.position.x + vagon2.size.width / 2 - 50, y: vagon2.position.y + 300}, size: {width: 100, height: 100}, image: conductor},
  { id: 'interactiveDoor2Top', position: {x: vagon2.position.x + vagon2.size.width / 2 - 50, y: vagon2.position.y}, size: {width: 100, height: 100}},
  { id: 'interactiveDoor2Down', position: {x: vagon2.position.x + vagon2.size.width / 2 - 50, y: vagon2.position.y + vagon2.size.height - 110}, size: {width: 100, height: 100}},

  { id: 'interactiveTrash', position: {x: vagon3.position.x + 20, y: vagon3.position.y + vagon3.size.height - 80}, size: {width: 50, height: 50}, image: trash},
  { id: 'interactiveDoor3Top', position: {x: vagon3.position.x + vagon3.size.width / 2 - 50, y: vagon3.position.y}, size: {width: 100, height: 100}},
  { id: 'interactiveDoor3Down', position: {x: vagon3.position.x + vagon3.size.width / 2 - 50, y: vagon3.position.y + vagon3.size.height - 110}, size: {width: 100, height: 100}},
];
